import type { WorkflowChangeSetItem } from '@/api/workflowChangeSets'

// Mirrors DocumentChangeSetHandler.FirstHeadingPattern.
const FIRST_HEADING = /^[ \t]{0,3}#[ \t]+(?<title>\S.*)$/m

function stripClosingHashes(raw: string): string {
  const isBlank = (ch: string) => ch === ' ' || ch === '\t'
  let end = raw.length
  while (end > 1 && isBlank(raw[end - 1])) end--
  while (end > 1 && raw[end - 1] === '#') end--
  while (end > 1 && isBlank(raw[end - 1])) end--
  return raw.slice(0, end)
}

type TitleSource = Pick<WorkflowChangeSetItem, 'title' | 'proposedValuesJson' | 'entityKind'>

// The item's own `title` is never edited — MatchPreviousItem pairs Create items across rounds
// on it — and a Document has no stored title at all, so it is re-derived from the content.
export function changeSetItemTitle(item: TitleSource): string {
  if (!item.proposedValuesJson) return item.title

  let proposed: Record<string, unknown>
  try {
    proposed = JSON.parse(item.proposedValuesJson) as Record<string, unknown>
  } catch {
    return item.title
  }

  if (item.entityKind === 'Document') {
    const content = proposed['content']
    const rawHeading = typeof content === 'string' ? FIRST_HEADING.exec(content)?.groups?.['title'] : undefined
    const heading = rawHeading && stripClosingHashes(rawHeading)
    if (heading) return heading.trim()
  }

  const proposedTitle = proposed['title']
  return typeof proposedTitle === 'string' && proposedTitle.trim() !== '' ? proposedTitle : item.title
}
